import { parse } from 'valibot';
import type { EntityResponse } from '@/shared/types/api';
import type {
	IDictionary,
	TDictionaries,
	TNames,
	Authors,
	FromEditTeam,
	FromPublisher,
	ShortList,
} from './../types';
import useRequest from '@/shared/composables/use-request';
import {
	dictionaryScheme,
	dictionaryArrayScheme,
	dictionaryNamesScheme,
	dictionaryPageFromEditTeamScheme,
	dictionaryPageFromPublisherScheme,
	dictionaryPageShortListScheme,
} from './schemes';

class Dictionaries {
	async fetchDictionariesNames(): EntityResponse<TNames> {
		try {
			const response = await useRequest().$get('/dictionaries/names/');

			if (response.status === 'error') {
				return response;
			}

			return parse(dictionaryNamesScheme, response.data);
		} catch (e) {
			console.error(e);
			throw e;
		}
	}

	async fetchDictionaryById(id: number): EntityResponse<IDictionary> {
		try {
			const response = await useRequest().$get(`/dictionaries/${id}/`);

			if (response.status === 'error') {
				return response;
			}

			return parse(dictionaryScheme, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchDictionaries(): EntityResponse<TDictionaries> {
		try {
			const response = await useRequest().$get('/dictionaries/');

			if ('error' in response) {
				return response;
			}

			return parse(dictionaryArrayScheme, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchDictionaryPageAuthors(id: string): EntityResponse<Authors> {
		try {
			const response = await useRequest().$get(`/dictionaries/${id}/authors/`);

			if (response.status === 'error') {
				return response;
			}

			// return parse(dictionaryPageAuthorScheme, response.data);
			return response.data as Authors;
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchDictionaryPageFromEditTeam(id: string): EntityResponse<FromEditTeam> {
		try {
			const response = await useRequest().$get(`/dictionaries/${id}/from_edit_team/`);

			if (response.status === 'error') {
				return response;
			}

			return parse(dictionaryPageFromEditTeamScheme, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchDictionaryPageFromPublisher(id: string): EntityResponse<FromPublisher> {
		try {
			const response = await useRequest().$get(`/dictionaries/${id}/from_publisher/`);

			if (response.status === 'error') {
				return response;
			}

			return parse(dictionaryPageFromPublisherScheme, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchDictionaryPageShortList(id: string): EntityResponse<ShortList> {
		try {
			const response = await useRequest().$get(`/dictionaries/${id}/short_list/`);

			if (response.status === 'error') {
				return response;
			}

			return parse(dictionaryPageShortListScheme, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}
}

export default new Dictionaries();
